import { cloneDeep } from 'lodash-es'
import { QueryStringKeys } from '@/constants/commons'
import { scrollToTop } from '@/utils/scroll'

interface UsePaginationOptions {
  pageSize: number
  shouldSavePageInURL?: boolean
  mode?: 'pagination' | 'infinite-scroll'
}

export function usePagination(opts: UsePaginationOptions) {
  const { pageSize, shouldSavePageInURL = true, mode = 'pagination' } = opts

  const route = useRoute()
  const router = useLocaleRouter()

  const queryPage = computed(() => route.query[QueryStringKeys.LIST_PAGE])
  const isPaginationMode = mode === 'pagination'

  const pagingState = reactive({
    page: Number(queryPage.value || 1),
    size: pageSize,
  })

  if (shouldSavePageInURL) {
    watch(queryPage, newQueryPage => {
      const newPage = Number(newQueryPage || 1)

      if (pagingState.page !== newPage) {
        pagingState.page = newPage
      }
    })

    watch(
      () => pagingState.page,
      newPage => {
        if (import.meta.client || import.meta.env?.TEST === 'true') {
          updateQueryPage(newPage)
        }
      }
    )
  }

  function updateQueryPage(page: number) {
    if (!shouldSavePageInURL) {
      return
    }

    const queries = cloneDeep(route.query)

    if (page === 1) {
      delete queries[QueryStringKeys.LIST_PAGE]
    } else {
      queries[QueryStringKeys.LIST_PAGE] = `${page}`
    }

    const hasQueryPageChanged = queries[QueryStringKeys.LIST_PAGE] !== route.query[QueryStringKeys.LIST_PAGE]

    if (hasQueryPageChanged) {
      router.push({ query: queries })
      isPaginationMode && scrollToTop()
    }
  }

  return { pagingState }
}
